/// <reference types="vite-plugin-svgr/client" />
import chroma from 'chroma-js';
import classNames from 'classnames';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import duration from 'dayjs/plugin/duration';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(duration);

dayjs.locale('zh-cn');

export * from './UIGenerator';
export * from './type';
export * from './hooks';
export * from './baseui';
export * from './store';
export * as MobxReactLite from 'mobx-react-lite';
export * as ArcoD from '@arco-design/web-react';
export * as Lo from 'lodash-es';
export * as ReactDnd from 'react-dnd';
export * as ReactQuery from '@tanstack/react-query';
export * as ReactUse from 'react-use';

export * as EasyVIcon from '@easyv/react-icons';
export * from './utils';

export * as EasyVComponents from '@easyv/react-components';

export { chroma, classNames };
